<template>
    <div class="loader" :class="{ cover }" v-bind="$attrs">
        <img src="images/loader.svg" />
        <div class="message" v-if="message">{{ message }}</div>
    </div>
</template>

<script>
export default {
    props: {
        message: {
            type: String,
            required: false,
            default: 'Laden…',
        },
        cover: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>
